import { computed } from 'vue';
import i18n                 from '../../i18n/i18n';
import { ALLHEADER, HEADER }    from '@/interfaces/SmartLink/Tables'


export const FINAL_HEADERS_TABLE:ALLHEADER  = {
    latency     : [
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.type')),           value: "tipo",          sortable: true },
        { text: computed(() => i18n.global.t('labels.latency')),        value: "latencia",      sortable: true },
    ],
    quality_lap : [
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.linkradiohoriz')), value: "link_radio_rx", sortable: true },
    ],
    quality_snr : [
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.snrHoriz')),       value: "snr_h",         sortable: true },
        { text: computed(() => i18n.global.t('labels.snrVerti')),       value: "snr_v",         sortable: true },
        // { text: computed(() => i18n.global.t('labels.avgpower')),       value: "avgpower",      sortable: true },
    ],
    temp_inst   : [
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.temperature')),    value: "temperatura",   sortable: true },
    ],      
    operability   : [               
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.ok')),             value: "ok",            sortable: true },
        { text: computed(() => i18n.global.t('labels.alert')),          value: "alert",         sortable: true },
        { text: computed(() => i18n.global.t('labels.alarm')),          value: "alarm",         sortable: true },
        { text: computed(() => i18n.global.t('labels.down')),           value: "down",          sortable: true },                
    ],
    wiredpeers   : [   
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.cost')),           value: "costo",         sortable: true },               
    ],
    wirelesspeers   : [               
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: false},
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.equipment')),      value: "name",          sortable: true },
        { text: computed(() => i18n.global.t('labels.cost')),           value: "costo",         sortable: true },                
    ],
    principal: [
        { text: computed(() =>  i18n.global.t('labels.oci')),           value: "ieo",           sortable: true },
        { text: computed(() =>  i18n.global.t('labels.type')),          value: "icon",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.type')),          value: "tipo",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.name')),          value: "name",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.ip')),            value: "ip",            sortable: true },
        { text: computed(() =>  i18n.global.t('labels.mark')),          value: "marca",         sortable: true },
    ],
    secundary: [
        { text: computed(() =>  i18n.global.t('labels.oci')),           value: "ieo",           sortable: true },
        { text: computed(() =>  i18n.global.t('labels.type')),          value: "icon",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.type')),          value: "tipo",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.name')),          value: "name",          sortable: true },
        { text: computed(() =>  i18n.global.t('labels.date')),          value: "fecha",         sortable: true },
        { text: computed(() =>  i18n.global.t('labels.ip')),            value: "ip",            sortable: true },
        { text: computed(() =>  i18n.global.t('labels.cause')),         value: "causa",         sortable: true },
        { text: computed(() =>  i18n.global.t('labels.detail')),        value: "detalle",       sortable: true },
    ],
    status: [
        { text: computed(() => i18n.global.t('labels.date')),           value: "fecha",         sortable: true },
        { text: computed(() => i18n.global.t('labels.ip')),             value: "ip",            sortable: true },
        { text: computed(() => i18n.global.t('labels.status')),         value: "status",        sortable: true },
        { text: computed(() => i18n.global.t('labels.cause')),          value: "causa",         sortable: true },
        { text: computed(() => i18n.global.t('labels.detail')),         value: "detalle",       sortable: true },
    ],
    virmac: [
        { text: computed(() => i18n.global.t('labels.status')),         value: "state",         sortable: true, },
        { text: computed(() => i18n.global.t('labels.virtMach')),       value: "mv",            sortable: true, },
        { text: computed(() => i18n.global.t('labels.cpu')),            value: "porcCPU",       sortable: true, width: 200},
        { text: computed(() => i18n.global.t('labels.memo')),           value: "porcMemor",     sortable: true, width: 200},
        { text: computed(() => i18n.global.t('labels.disc')),           value: "porcDisco",     sortable: true, width: 200},          
    ],
    wire_inst   : [],
    pack_inst   : [],

};

export const RESET_HEADER = [
    { text: 'Nombre',           value: "id",         sortable: true},
]


export const HEAD_WLAN:HEADER[] = [
    { text: 'MAC',           value: "mac",         sortable: false},
    { text: 'Type',          value: "type",        sortable: false},
    { text: 'Rate',          value: "rate",        sortable: false},
    { text: 'RSSI',          value: "rssi",        sortable: false},
    { text: 'Signal',        value: "signal",      sortable: false},
    { text: 'SSID',          value: "ssid",        sortable: false},
]